var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24039 10.2799H8.76039V11.7999H7.24039V10.2799ZM7.24039 4.1999H8.76039V8.7599H7.24039V4.1999ZM7.99279 0.399902C3.79759 0.399902 0.400391 3.8047 0.400391 7.9999C0.400391 12.1951 3.79759 15.5999 7.99279 15.5999C12.1956 15.5999 15.6004 12.1951 15.6004 7.9999C15.6004 3.8047 12.1956 0.399902 7.99279 0.399902ZM8.00039 14.0799C4.64119 14.0799 1.92039 11.3591 1.92039 7.9999C1.92039 4.6407 4.64119 1.9199 8.00039 1.9199C11.3596 1.9199 14.0804 4.6407 14.0804 7.9999C14.0804 11.3591 11.3596 14.0799 8.00039 14.0799Z",
    fill: "#DA291C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutlined);
export default __webpack_public_path__ + "static/media/ErrorOutlined.5e9d5bd3450135daa2f2d0963e8e0a35.svg";
export { ForwardRef as ReactComponent };